import React from "react";

const UserIcon = () => {
  return (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.0001 1.3252C7.03259 1.3252 5.4376 2.92018 5.4376 4.8877C5.4376 6.85521 7.03259 8.4502 9.0001 8.4502C10.9676 8.4502 12.5626 6.85521 12.5626 4.8877C12.5626 2.92018 10.9676 1.3252 9.0001 1.3252ZM6.5626 4.8877C6.5626 3.5415 7.65391 2.4502 9.0001 2.4502C10.3463 2.4502 11.4376 3.5415 11.4376 4.8877C11.4376 6.23389 10.3463 7.3252 9.0001 7.3252C7.65391 7.3252 6.5626 6.23389 6.5626 4.8877Z"
        fill="#344054"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.0001 9.5752C7.26494 9.5752 5.66629 9.96961 4.48169 10.6359C3.31471 11.2924 2.4376 12.2872 2.4376 13.5127L2.43755 13.5892C2.4367 14.4605 2.43564 15.5542 3.39491 16.3354C3.86701 16.7198 4.52746 16.9932 5.41976 17.1738C6.31455 17.3549 7.48077 17.4502 9.0001 17.4502C10.5194 17.4502 11.6857 17.3549 12.5804 17.1738C13.4727 16.9932 14.1332 16.7198 14.6053 16.3354C15.5646 15.5542 15.5635 14.4605 15.5626 13.5892L15.5626 13.5127C15.5626 12.2872 14.6855 11.2924 13.5185 10.6359C12.3339 9.96961 10.7353 9.5752 9.0001 9.5752ZM3.5626 13.5127C3.5626 12.8742 4.02863 12.1816 5.03323 11.6165C6.0202 11.0613 7.42156 10.7002 9.0001 10.7002C10.5786 10.7002 11.98 11.0613 12.967 11.6165C13.9716 12.1816 14.4376 12.8742 14.4376 13.5127C14.4376 14.4935 14.4074 15.0457 13.8949 15.463C13.617 15.6893 13.1525 15.9102 12.3573 16.0712C11.5645 16.2316 10.4808 16.3252 9.0001 16.3252C7.51943 16.3252 6.43565 16.2316 5.64294 16.0712C4.84774 15.9102 4.38319 15.6893 4.10529 15.463C3.59284 15.0457 3.5626 14.4935 3.5626 13.5127Z"
        fill="#344054"
      />
    </svg>
  );
};

export default UserIcon;
